import type { DateTimeValue } from '@elfsight/configurator-contracts';
import { getDateFromString } from './get-date-from-string';

export function getDateFromControlValue(
  start: DateTimeValue<'datetime'> | undefined
) {
  if (start) {
    return getDateFromString(start.date + ' ' + start.time);
  }

  return new Date();
}
